import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/guide/what-is-freediving/page.tsx");
